import { IconSpinner } from '@cleanlab/design-system/icons'
import { AnimatePresence, motion } from 'motion/react'

export const LoadingScreen = () => (
  <AnimatePresence>
    <motion.div
      key="loader"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, scale: 0 }}
      transition={{ duration: 1.5, ease: 'easeOut' }}
      className="pointer-events-none absolute inset-0 flex h-screen items-center justify-center"
    >
      <IconSpinner animate size={40} className="text-text-faint opacity-50" />
    </motion.div>
  </AnimatePresence>
)
